<template>
  <div>

    <vue-topprogress ref="loadingProgress"></vue-topprogress>

    <div v-if="!loading && thread">

      <h1 class="display-4 font-weight-lighter">
        {{ thread.title }}
        <div class="d-inline-block float-right" v-if="$store.getters.isAdmin">
          <b-button-group v-if="thread">
            <b-button variant="outline-dark" squared v-b-modal.edit-thread><font-awesome-icon :icon="['fal', 'pencil']"></font-awesome-icon></b-button>
            <b-button variant="outline-danger" squared @click="deleteThread"><font-awesome-icon :icon="['fal', 'trash']"></font-awesome-icon></b-button>
          </b-button-group>
          <knowledgebase-thread-modal modal_id="edit-thread" :existing_thread="thread" @onSaved="fetch"></knowledgebase-thread-modal>
        </div>
      </h1>

      <br />

      <p>{{ thread.body }}</p>

      <h3 class="mb-0">Posts</h3>

      <br />

      <div v-if="posts && posts.length">
        <div v-for="(post, index) in posts">
          <p>{{ post.post }}</p>
          <div class="clearfix">
            <span class="text-muted" style="font-size: 0.7rem">
              Posted at {{ post.created_at | moment("MMM D, YYYY h:mm a") }} by {{ post.poster }}
              <b-button v-if="$store.getters.isAdmin" class="m-0 p-0 pl-3" variant="link"  style="font-size: 0.7rem"  @click="deletePost(post, index)">Delete</b-button>
            </span>
          </div>
          <hr>
        </div>
      </div>
      <div v-if="!(posts && posts.length)">
        <b-alert show>Their are currently no replies to this thread. Be the first to reply.</b-alert>
      </div>

      <b-alert :show="request_err" variant="warning">{{ request_err }}</b-alert>
      <c-textarea
        v-model="reply"
        :isValid="(reply_validated ? (reply_validated === true) : null)"
        :invalidFeedback="reply_validated"
      ></c-textarea>
      <div class="d-inline-block">
        <b-overlay :show="replying" spinner-small>
          <c-button class="btn-sf btn-square" @click="createReply">Reply</c-button>
        </b-overlay>
      </div>

    </div>

  </div>
</template>

<script>

import KnowledgebaseThread from "../../../models/KnowledgebaseThread";
import KnowledgebasePost from "../../../models/KnowledgebasePost";
import KnowledgebaseThreadModal from "../../../components/tools/faq/KnowledgebaseThreadModal";

export default {
  name: 'KnowledgebaseThreadDetail',
  components: {KnowledgebaseThreadModal},
  data() {
    return {
      thread_id: this.$route.params.knowledgebase_thread_id,
      thread: null,
      posts: null,
      loading: true,
      reply: null,
      replying: false,
      reply_validated: null,
      request_err: null
    };
  },
  methods: {
    fetch() {
      this.$refs.loadingProgress.start();
      this.loading = true;
      KnowledgebaseThread.api().retrieve(this.thread_id).then((response) => {
        let thread = response.entities[KnowledgebaseThread.entity][0];
        KnowledgebasePost.api().fetch({knowledgebase_thread_id: this.thread_id}).then((p_response) => {
          this.thread = thread;
          this.posts = p_response.entities[KnowledgebasePost.entity];
          this.$refs.loadingProgress.done();
          this.loading = false;
        });
      });
    },
    createReply() {
      this.replying = true;
      this.request_err = null;
      if(!this.reply || this.reply === '') {
        this.reply_validated = 'Please enter a reply.';
        this.replying = false;
        return false;
      }
      let payload = {
        knowledgebase_thread_id: this.thread_id,
        post: this.reply,
      };
      return KnowledgebasePost.api().create(payload).then((response) => {
        if(!this.posts) {
          this.posts = [];
        }
        this.posts.push(response.entities[KnowledgebasePost.entity][0]);
        this.reply = null;
        this.replying = false;
      }, () => {
        this.request_err = 'The post could not be submitted at this time. Please try again.';
        this.replying = false;
        return false;
      });
    },
    deletePost(post, index) {
      KnowledgebasePost.api().remove(post.id).then(() => {
        this.posts.splice(index, 1);
      });
    },
    deleteThread() {
      KnowledgebaseThread.api().remove(this.thread_id).then(() => {
        this.$router.push('/tools/faq')
      });
    }
  },
  mounted() {
    this.fetch();
  }
}
</script>
